import { Component, OnInit } from '@angular/core';
import { IInstance } from './instances-list.models';
import { HttpClient } from '@angular/common/http';
import { AsyncPipe } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { env } from '../../../env/env';

@Component({
  selector: 'instances-list',
  templateUrl: './instances-list.component.html',
  styleUrls: ['./instances-list.component.css'],
  imports: [
    AsyncPipe
  ]
})
export class InstancesListComponent implements OnInit {

  constructor(private httpClinet: HttpClient) { }

  public appInstances: Subject<Array<IInstance>> = new Subject();

  ngOnInit() {
    this.loadAppInstances();
  }

  public loadAppInstances() {
    this.httpClinet.get(`${env.apiUrl}/app-instances`).subscribe({
      next: s => {
        this.appInstances.next(s as IInstance[]);
      }
    });
  }

  public selectInstance(instance: IInstance): void {
    window.location.assign(`/instances/${instance.id}`);
  }
}
